<template>
    <v-card>
        <v-card-title class="justify-center">{{ group.name }}</v-card-title>

        <p class="text-center">
            Kamu dapat memulai tryout setelah ketua kelompok membayar biaya pendaftaran dan admin sudah mengaktifkan kelompok ini.
        </p>

        <member-list></member-list>
    </v-card>
</template>

<script>
import MemberList from './MemberList'

export default {
    props: ['group'],

    components: {
        MemberList,
    },
}
</script>
